"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hexDependencies = void 0;

var _dependenciesFormatGenerated = require("./dependenciesFormat.generated.js");

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var hexDependencies = {
  formatDependencies: _dependenciesFormatGenerated.formatDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createHex: _factoriesAny.createHex
};
exports.hexDependencies = hexDependencies;